import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AuthenticationService } from '../services/authentication.service';
import { SharedModule } from '../shared/shared.module';
import { VddOnboardingService } from './services/vdd-onboarding.service';
import { VddOnboardingForm } from './vdd.interface';

const initialValues: VddOnboardingForm = {
  companyName: '',
  ein: '',
  contactName: '',
  contactEmail: '',
  contactPhone: '',
  packageType: 'full',
};

@Component({
  standalone: true,
  selector: 'app-vdd-onboarding-page',
  templateUrl: './vdd-onboarding-page.component.html',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    SharedModule,
    MatIconModule,
  ],
})
export class VddOnboardingPageComponent {
  values: VddOnboardingForm = initialValues;
  successMessage = '';
  errorMessage = '';
  isLoading = false;
  orgCode: string | null = null;

  constructor(
    private vddOnboardingService: VddOnboardingService,
    private authenticationService: AuthenticationService,
  ) {
    this.orgCode = this.authenticationService.orgCode;
  }

  packageOptions: { label: string; value: VddOnboardingForm['packageType'] }[] = [
    { label: 'Full', value: 'full' },
    { label: 'Limited', value: 'limited' },
  ];

  propertyTypeOptions: { label: string; value: VddOnboardingForm['propertyType'] }[] = [
    { label: 'Not Publicly Traded', value: 'not_publicly_traded' },
    { label: 'Publicly Traded', value: 'publicly_traded' },
    { label: 'Subsidiary of a PTC - Full License', value: 'subsidiary_ptc_full_license' },
    { label: 'Subsidiary of a PTC - Restricted License', value: 'subsidiary_ptc_restricted_license' },
    { label: 'Restricted License', value: 'restricted_license' },
    { label: 'Tribal', value: 'tribal' },
  ];

  onSubmit() {
    this.isLoading = true;
    this.successMessage = '';
    this.errorMessage = '';

    this.vddOnboardingService.sendOnboardingEmail(this.values).subscribe({
      next: () => {
        this.successMessage =
          'VDD onboarding request sent successfully! The vendor will receive an email to the contact email with further instructions in a few minutes.';
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error sending VDD onboarding request:', error);
        this.errorMessage = 'An error occurred. Please try again in a few minutes.';
        this.isLoading = false;
      },
    });
  }

  clearMessages() {
    this.successMessage = '';
    this.errorMessage = '';
  }
}
